export const logout = async (instance: any) => {
  if (instance) {
    const knownAuthorities = instance.getConfiguration().auth.knownAuthorities;
    const activeAccount = instance?.getActiveAccount();
    if (activeAccount?.environment && activeAccount?.environment !== knownAuthorities[0])
      // clear cache if the user is not in the known authority
      try {
        await instance.clearCache();
      } catch (error) {
        // console.error("Error clearing cache", error);
      }
    await instance.logoutRedirect();
  }
};
